<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5"
          >{{ !selectPreguntaEncuesta ? "Agregar" : "Editar" }} Pregunta
          Encuesta</label
        >
      </header>
      <form
        [formGroup]="formPreguntaEncuesta"
        (ngSubmit)="onOperarPreguntaEncuesta()"
      >
        <div class="form-group">
          <label class="small text-secondary" for="nit">Año</label>
          <input
            id="anio"
            formControlName="anio"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="modulo_encuesta_id"
            >Módulo</label
          >
          <select
            class="form-control form-control-sm"
            id="modulo_encuesta_id"
            formControlName="modulo_encuesta_id"
          >
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option
              class=""
              *ngFor="let option of moduloEncuestaByAnio; let i = index"
              [ngValue]="option?.modulo_encuesta_id"
            >
              {{ option?.descripcion }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="seccion_encuesta_id">Sección</label>
          <select
            class="form-control form-control-sm"
            id="seccion_encuesta_id"
            formControlName="seccion_encuesta_id"
          >
            <option [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option
              *ngFor="let option of seccionEncuestaByModulo; let i = index"
              [ngValue]="option?.seccion_encuesta_id"
            >
              {{ option?.titulo }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit"
            >Tipo de Pregunta</label
          >
          <select
            class="form-control form-control-sm"
            id="tipo_pregunta_encuesta_id"
            formControlName="tipo_pregunta_encuesta_id"
            (change)="cambioTipoPreguntaEncuesta(null, null)"
          >
            <option [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option
              *ngFor="let option of tipoPreguntaEncuesta; let i = index"
              [ngValue]="option?.tipo_pregunta_encuesta_id"
            >
              {{ option?.descripcion }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Orden</label>
          <input
            id="orden"
            formControlName="orden"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Descripción</label>
          <input
            id="descripcion"
            formControlName="descripcion"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
        <ng-container
          *ngIf="formPreguntaEncuesta.value.tipo_pregunta_encuesta_id == tipo_pregunta_multiple"
        >
          <div class="form-group">
            <label class="small text-secondary" for="nit">Prioritario</label>
            <select
              class="form-control form-control-sm"
              id="con_prioridad"
              formControlName="con_prioridad"
            >
              <option [ngValue]="null" selected="true">
                Seleccione
              </option>
              <option [ngValue]="true">Sí</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
        </ng-container>
        <ng-container
          *ngIf="formPreguntaEncuesta.value.tipo_pregunta_encuesta_id == tipo_pregunta_abierta"
        >
          <div class="form-group">
            <label class="small text-secondary" for="nit"
              >Tipo de Dato</label
            >
            <select
              class="form-control form-control-sm"
              id="pregunta_tipo_valor_id"
              formControlName="pregunta_tipo_valor_id"
            >
              <option class="" [ngValue]="null" selected="true">
                Seleccione
              </option>
              <option
                *ngFor="let option of tipoValorLista; let i = index"
                [ngValue]="option?.pregunta_tipo_valor_id"
              >
                {{ option?.pregunta_tipo_valor_descripcion }}
              </option>
            </select>
          </div>
        </ng-container>
        <ng-container
          *ngIf="formPreguntaEncuesta.value.tipo_pregunta_encuesta_id == tipo_pregunta_abierta ||
          formPreguntaEncuesta.value.tipo_pregunta_encuesta_id == tipo_pregunta_multiple"
          formGroupName="longitudGroup"
        >
          <div class="form-group">
            <label class="small text-secondary" for="nit"
              >Longitud Mínima</label
            >
            <input
              id="longitud_minima"
              formControlName="longitud_minima"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="nit"
              >Longitud Máxima</label
            >
            <input
              id="longitud_maxima"
              formControlName="longitud_maxima"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
        </ng-container>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Obligatorio</label>
          <select
            class="form-control form-control-sm"
            id="es_obligatoria"
            formControlName="es_obligatoria"
          >
            <option [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option [ngValue]="true">Sí</option>
            <option [ngValue]="false">No</option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Estado</label>
          <select
            class="form-control form-control-sm"
            id="activo"
            formControlName="activo"
            [attr.disabled]="!selectPreguntaEncuesta ? '' : null"
          >
            <option [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option [ngValue]="true">Activo</option>
            <option [ngValue]="false">Inactivo</option>
          </select>
        </div>
        <div class="form-row mt-5">
          <button
            type="button"
            class="btn btn-outline-primary border-0 m-auto"
            (click)="limpiarRespuestaAdicional()"
          >
            Limpiar
          </button>
          <button
            class="btn btn-primary m-auto"
            [disabled]="!formPreguntaEncuesta.valid"
            type="submit"
          >
            {{ !selectPreguntaEncuesta ? "Agregar" : "Editar" }}
          </button>
        </div>
      </form>
    </section>
    <section class="col-9 p-4 mt-5 mb-5">
      <div class="d-flex justify-content-between">
        <div>
          <img
            src="../../../../../assets/icons/solicitud.png"
            class="d-inline-block img-responsive mr-3"
            alt=""
          />
          <label class="h5">Listado de Preguntas Encuesta</label>
        </div>
        <p>
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed"
            aria-controls="filtros"
          >
            Ver filtros
          </button>
        </p>
      </div>

      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Año</label>
                  <input
                    id="anio"
                    formControlName="anio"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="modulo_encuesta_id_filtro"
                    >Módulo</label
                  >
                  <select
                    class="form-control form-control-sm"
                    id="modulo_encuesta_id_filtro"
                    formControlName="modulo_encuesta_id"
                  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option
                      class=""
                      *ngFor="let option of moduloEncuestaByAnioFiltro; let i = index"
                      value="{{ option?.modulo_encuesta_id }}"
                      [selected]="false"
                    >
                      {{ option?.descripcion }}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Sección</label
                  >
                  <select
                    class="form-control form-control-sm"
                    id="seccion_encuesta_id"
                    formControlName="seccion_encuesta_id"
                  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option
                      class=""
                      *ngFor="let option of seccionEncuestaByModuloFiltro; let i = index"
                      value="{{ option?.seccion_encuesta_id }}"
                      [selected]="false"
                    >
                      {{ option?.titulo }}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Tipo de Pregunta</label
                  >
                  <select
                    class="form-control form-control-sm"
                    id="tipo_pregunta_encuesta_id"
                    formControlName="tipo_pregunta_encuesta_id"
                  >
                    <option [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option
                      *ngFor="let option of tipoPreguntaEncuesta; let i = index"
                      [ngValue]="option?.tipo_pregunta_encuesta_id"
                    >
                      {{ option?.descripcion }}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Orden</label>
                  <input
                    id="orden"
                    formControlName="orden"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Descripción</label
                  >
                  <input
                    id="descripcion"
                    formControlName="descripcion"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>

                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Tipo de Dato</label
                  >
                  <select
                    class="form-control form-control-sm"
                    id="pregunta_tipo_valor_id"
                    formControlName="pregunta_tipo_valor_id"
                  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option
                      class=""
                      *ngFor="let option of tipoValorLista; let i = index"
                      value="{{ option?.pregunta_tipo_valor_id }}"
                    >
                      {{ option?.pregunta_tipo_valor_descripcion }}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Longitud Mínima</label
                  >
                  <input
                    id="longitud_minima"
                    formControlName="longitud_minima"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Longitud Máxima</label
                  >
                  <input
                    id="longitud_maxima"
                    formControlName="longitud_maxima"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>

                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Obligatorio</label
                  >
                  <select
                    class="form-control form-control-sm"
                    id="es_obligatoria"
                    formControlName="es_obligatoria"
                  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Estado</label>
                  <select
                    class="form-control form-control-sm"
                    id="activo"
                    formControlName="activo"
                  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Activo
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Inactivo
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button
                    type="reset"
                    class="btn btn-outline-primary border-0 m-auto"
                    (click)="limpiar()"
                  >
                    Limpiar
                  </button>
                  <button
                    class="btn btn-primary m-auto solicitud-btn-principal"
                    type="submit"
                  >
                    Filtrar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <app-tablas
          [page]="paginaActual"
          [headers]="headerPreguntaEncuesta"
          [sizeData]="dataTabla.paging.totalItems"
          (paginado)="onPaginado($event)"
          class="table-responsive"
        >
          <tr *ngFor="let item of dataTabla.items; let i = index" class="small">
            <td>{{ item.descripcion_seccion_encuesta }}</td>
            <td>{{ item.anio }}</td>
            <td>{{ item.descripcion_tipo_pregunta }}</td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.pregunta_tipo_valor_descripcion }}</td>
            <td>{{ item.longitud_minima }}</td>
            <td>{{ item.longitud_maxima }}</td>
            <td>{{ item.es_obligatoria ? "Sí" : "No" }}</td>
            <td>{{ item.orden }}</td>
            <td>{{ item.activo ? "Activo" : "Inactivo" }}</td>
            <td class="d-flex flex-row">
              <img
                src="../../../../../../../assets/icons/edit.png"
                class="pointer"
                alt=""
                height="25"
                (click)="onCargarPreguntaEncuesta(item)"
              />
              <img
                src="../../../../../../../assets/icons/delete.png"
                class="pointer"
                alt=""
                height="25"
                (click)="onEliminarPreguntaEncuesta(item)"
              />
            </td>
            <td>
              <ng-template #popContent>
                <ng-container *ngIf="item.tipo_pregunta_encuesta_id === tipo_pregunta_lista_valor">
                  <button class="btn btn-outline-light border-0 text-left w-100"
                    (click)="onOpenModalListaValor(item)">Lista Valor</button>
                  <button class="btn btn-outline-light border-0 text-left w-100"
                    (click)="onOpenModalEnlace(item)">Enlace</button>
                </ng-container>
                <ng-container *ngIf="item.tipo_pregunta_encuesta_id === tipo_pregunta_formula">
                  <button class="btn btn-outline-light border-0 text-left w-100"
                    (click)="onOpenModalPreguntaFormulada(item)">Formulada</button>
                </ng-container>
                <ng-container *ngIf="item.tipo_pregunta_encuesta_id === tipo_pregunta_abierta || item.tipo_pregunta_encuesta_id === tipo_pregunta_formula">
                  <button class="btn btn-outline-light border-0 text-left w-100"
                    (click)="onOpenModalPreguntaCondicionada(item)">Condicionada</button>
                </ng-container>
                <button class="btn btn-outline-light border-0 text-left w-100"
                  (click)="onOpenModalPreguntaCondicionBloqueo(item)">Bloqueo</button>
              </ng-template>
              <button type="button" class="btn btn-outline-secondary text-center" placement="bottom"
                [ngbPopover]="popContent" popoverClass="bg-dark">
                ..
              </button>
            </td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>
